// extracted by mini-css-extract-plugin
module.exports = {"ActionBar":"MccPendingApprovals_ActionBar__21iIa","AggregatorSearch":"MccPendingApprovals_AggregatorSearch__2HPDH"};